import React from 'react';

import { Radio } from '@mui/material';

import classes from './CoachRow.module.scss';
import { Coach } from '../../../../../../interfaces/coachList/CoachListInfo';
import { AvatarIcon } from '../../../../../../../shared/components/ui-components';
import { SelectableCard } from '../../../../../../../shared/components/form-components';

type CoachRowProps = {
  coach: Coach;
  selectedCoachId?: number | null;
  onClick: (coach: Coach) => void;
};

const CoachRow = ({ coach, selectedCoachId, onClick }: CoachRowProps) => {
  const checked = selectedCoachId === coach.coachId;

  const handleClick = () => {
    onClick(coach);
  };

  return (
    <SelectableCard
      className={classes.row}
      variant="outBox"
      onClick={handleClick}
      data-test-id="coach-row"
    >
      <div className={classes.coachCell}>
        <Radio checked={checked} />
        <AvatarIcon userName={coach.coachName} avatarImgLink={coach.coachAvatar} />
        <div> {coach.coachName}</div>
      </div>
    </SelectableCard>
  );
};

export { CoachRow };
